import { useChinaDetector } from '../../../common/region-locale'
import PdImage from '../../../components/pd-image/pd-image'
import { useD9 } from '../../../hooks/use-d9-data'
import { useMobileDetector } from '../../../hooks/use-mobile-detector'

export function Section4() {
  const { section4 } = useD9()
  const inChina = useChinaDetector()
  const isMobile = useMobileDetector()

  return (
    <div className="w-full h-fit laptop:px-0 px-6 laptop:pt-30 laptop:pb-0 py-15 bg-[#141415]">
      <div className="header w-300 max-w-full mx-auto flex flex-col laptop:gap-6 gap-3 laptop:items-center items-start">
        <h2 className="text-white/90 laptop:text-5xl text-2xl font-semibold">{section4.title}</h2>
        <h3 className="text-white/90 text-base laptop:text-lg font-normal">{section4.subTitle}</h3>
      </div>

      <div className="w-full flex flex-col laptop:flex-row mt-8 laptop:mt-16 gap-3 laptop:gap-[2px] laptop:bg-black">
        <figure className="relative w-full laptop:w-1/2 h-358px laptop:h-[37.5vw] shrink">
          <PdImage
            src={section4.handBackImage}
            width="100%"
            height="100%"
            object="contain"
            objectPosition="top"
            useLoader
          />
        </figure>
        <figure className="relative w-full laptop:w-1/2 h-358px laptop:h-[37.5vw] shrink">
          <PdImage
            src={section4.handFrontImage}
            width="100%"
            height="100%"
            object="contain"
            objectPosition="top"
            useLoader
          />
        </figure>
      </div>

      <div className="spec w-full mx-auto pt-8 laptop:pt-16 laptop:pb-30 laptop:bg-black">
        <dl className="w-300 max-w-full mx-auto grid grid-cols-2 laptop:grid-cols-4 gap-x-3 laptop:gap-x-0 gap-y-8 laptop:gap-y-16">
          {section4.spec.map((item, index) => {
            // 对degrees of freedom 做特殊处理
            if (index === 3 && !inChina && isMobile) {
              return (
                <div key={item[0]}>
                  <dd className="text-white/90 text-[1.75rem] laptop:text-42 font-['Montserrat'] font-bold">
                    <span>{item[1].substring(0, 2)}</span>
                    <span className="text-xl">{item[1].substring(2)}</span>
                  </dd>
                  <dt className="mt-1 laptop:mt-2 text-white/60 text-sm laptop:text-base font-normal">{item[0]}</dt>
                </div>
              )
            }

            return (
              <div key={item[0]}>
                <dd className="text-white/90 text-[1.75rem] laptop:text-42 font-['Montserrat'] font-bold">{item[1]}</dd>
                <dt className="mt-1 laptop:mt-2 text-white/60 text-sm laptop:text-base font-normal">{item[0]}</dt>
              </div>
            )
          })}
        </dl>
      </div>
    </div>
  )
}
